import apiV2 from '../../../api-v2';
import FiltersType from './listingFiltersTypesConstants';

export default {
  path: '/leaves',
  filters: [
    {
      key: 'fulltext',
      placeholder: 'Wpisz frazę do znalezienia',
      shortPlaceholder: 'Szukaj',
      badge: 'Szukana fraza:',
      testName: 'leave-filter-fulltext',
      inputType: FiltersType.TEXT_SEARCH_TYPE,
      reset: async () => ({ value: '' }),
    },
    {
      key: '_leave_code',
      getItems: async () => {
        const { data } = await apiV2.staff.leaveCode.list();
        delete data.pagination;
        return Object.values(data).map(e => ({ label: e.name, value: e.id }));
      },
      reset: async () => null,
      placeholder: '',
      badge: 'Kod przerwy',
      testName: 'leave-filter-leave-code',
      inputType: FiltersType.MULTI_SELECT_TYPE,
    },
    {
      key: '_leave_date_range',
      reset: async () => ({ value: { fromVal: null, toVal: null } }),
      placeholder: '',
      badge: 'Okres przerwy',
      testName: 'leave-filter-leave-date-range',
      inputType: FiltersType.RANGE_TYPE,
      htmlInputType: 'date',
    },
  ],
};
